import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {Body} from 'shells/typography/body';

import {MAX_FIELDS} from './create-or-edit-widget-form';

type Props = {
    isDisabled: boolean;
    onComplete: () => void;
    maxReached: boolean;
    disabledTooltip?: string;
};

export function CreateOrEditWidgetFooter(props: Props) {
    return (
        <div className='px-24 py-16 flex justify-sb align-center border-top'>
            <div>
                {props.maxReached && (
                    <Body color='error' size='small'>
                        * You have reached the maximum of {MAX_FIELDS} custom fields per widget.
                    </Body>
                )}
            </div>
            <SaveButton
                // @ts-expect-error
                onClick={props.onComplete}
                isSaving={false}
                buttonText='Done'
                disabled={props.isDisabled}
                disabledTooltip={props.disabledTooltip}
            />
        </div>
    );
}
